import { useEffect } from 'react'
import { DOCS, type Doc } from './documents'
import { LegalBody } from './LegalBody'

/**
 * A legal document as a PUBLIC PAGE — what `app.avengents.ai/privacy` and `/terms`
 * show. This is the URL App Store Connect is given and the one a reviewer, a
 * regulator or a person who has never signed in opens, so it renders outside the
 * app entirely: no session, no providers, no sign-in gate (main.tsx routes here
 * before any of that boots). The words are `documents.ts` through `LegalBody`, the
 * same as the in-app sheet — one source, one renderer, two frames.
 */
export function LegalPage({ doc }: { doc: Doc }) {
  useEffect(() => {
    document.title = `${doc.title} · Avengents`
  }, [doc])
  return (
    <main className="legal-page">
      <header className="legal-page-head">
        <a className="legal-page-home" href="/">
          Avengents
        </a>
        <nav className="legal-page-nav" aria-label="Legal documents">
          {DOCS.map((d) =>
            d.id === doc.id ? (
              <span key={d.id} aria-current="page">
                {d.title}
              </span>
            ) : (
              <a key={d.id} href={`/${d.id}`}>
                {d.title}
              </a>
            ),
          )}
        </nav>
      </header>
      <h1>{doc.title}</h1>
      <LegalBody doc={doc} />
    </main>
  )
}
